export const routes = {
  home: {
    path: '/',
  },
  oleshky: {
    path: '/oleshky',
  },
  reel: {
    path: '/reel',
  },
  leftBank: {
    path: '/left-bank',
  },
  action: {
    path: '/action',
  },
  witnesses: {
    path: '/witnesses',
  },
  rallies: {
    path: '/rallies',
  },
  help: {
    path: '/help',
  },
  resources: {
    path: '/resources',
  },
}
